import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import Box from '../box/box.jsx'
import Modal from '../../containers/modal.jsx'

import styles from './device-redirect-modal.css'

const DeviceRedirectModal = (props) => {
    const currentVersionSuffix = props.currentVersion
        ? ` (v${props.currentVersion})`
        : ''

    return (
    <Modal
        className={styles.modalContent}
        headerClassName={styles.header}
        contentLabel={
            <FormattedMessage
                defaultMessage="Connected Device Detected"
                description="Title of the dialog asking to switch to the connected device"
                id="gui.deviceRedirectModal.title"
            />
        }
        id="deviceRedirectModal"
        onRequestClose={props.onCancel}
    >
        <Box className={styles.body}>
            <p className={styles.message}>
                {props.currentLabel ? (
                    <FormattedMessage
                        defaultMessage="You're currently set up for {currentLabel}{currentVersionSuffix}, but the connected device is {targetLabel} (v{targetVersion})."
                        description="Message shown when the connected device doesn't match the current workspace device"
                        id="gui.deviceRedirectModal.mismatch"
                        values={{
                            currentLabel: <strong>{props.currentLabel}</strong>,
                            currentVersionSuffix,
                            targetLabel: <strong>{props.targetLabel}</strong>,
                            targetVersion: props.targetVersion,
                        }}
                    />
                ) : (
                    <FormattedMessage
                        defaultMessage="No device is currently selected. We detected {targetLabel} (v{targetVersion}) connected."
                        description="Message shown when no device was previously selected"
                        id="gui.deviceRedirectModal.noCurrent"
                        values={{
                            targetLabel: <strong>{props.targetLabel}</strong>,
                            targetVersion: props.targetVersion,
                        }}
                    />
                )}
            </p>
            <p className={styles.message}>
                <FormattedMessage
                    defaultMessage="Do you want to switch to the connected device? The page will reload."
                    description="Asks the user to confirm switching device; the page will reload"
                    id="gui.deviceRedirectModal.confirmPrompt"
                />
            </p>
            <Box className={styles.buttonRow}>
                <button
                    className={styles.cancelButton}
                    onClick={props.onCancel}
                >
                    <FormattedMessage
                        defaultMessage="Cancel"
                        description="Button to stay on the current device"
                        id="gui.deviceRedirectModal.cancel"
                    />
                </button>
                <button
                    className={styles.confirmButton}
                    onClick={props.onConfirm}
                >
                    <FormattedMessage
                        defaultMessage="Redirect & Reload"
                        description="Button to switch to the connected device and reload"
                        id="gui.deviceRedirectModal.confirm"
                    />
                </button>
            </Box>
        </Box>
    </Modal>
    )
}

DeviceRedirectModal.propTypes = {
    currentLabel: PropTypes.string,
    currentVersion: PropTypes.string,
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    targetLabel: PropTypes.string.isRequired,
    targetVersion: PropTypes.string.isRequired,
}

export default DeviceRedirectModal
